<template>
    <div class="anchor-brief">
        <div class="anchor-brief-bg" :style="{ background: `url(${hostBg}) 0% 0% / cover` }">
            <img :src="hostBg" alt="">
        </div>
        <div class="anchor-brief-mask"></div>
        <!-- 主播基础信息 -->
        <div class="anchor-brief-header">
            <!-- <img class="header-img" :src="anchorInfo.headImg && anchorInfo.headImg.url" alt=""/> -->
            <img
                v-if="anchorInfo.headImg && anchorInfo.headImg.url"
                class="header-img"
                v-lazy="handleImg({ url: anchorInfo.headImg.url, width: 120, height: 120 })"
                alt=""
            />
            <img
                v-else
                class="header-img"
                v-lazy="handleImg({ url: defaultHead, width: 120, height: 120 })"
                alt=""
            />
            <div class="header-name">{{ anchorInfo.userName }}</div>
            <!-- <Personal class="personal" :certification="certification" :through="false"/> -->
            <!-- <div v-if="anchorInfo.height || anchorInfo.weight || anchorInfo.constellation" class="header-body">
              <span v-if="anchorInfo.height">{{ `${$t('message.anchor.height')}：${anchorInfo.height}` }}cm</span>
              <span v-if="anchorInfo.weight">{{ `${$t('message.anchor.weight')}：${anchorInfo.weight}` }}kg</span>
              <span v-if="anchorInfo.constellation">{{ `${$t('message.anchor.zodiac')}：${anchorInfo.constellation}` }}</span>
            </div> -->
            <div class="header-focus">
                <div class="header-focus-text">
                    <span
                        >{{ changeNum() }}: {{ transPeople(anchorInfo.likeCount) }}</span
                    >
                </div>
                <div v-if="anchorInfo.userlikeHost" class="header-focus-btn global_pointer" @click="unconcernHostConfim">
                    {{ $t('message.anchor.cancelFollow') }}
                </div>
                <div v-else class="header-focus-btn global_pointer" @click="concernHost">{{ $t('message.anchor.follow') }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import api from "@/api/api_list";
import { transPeople } from '@/utils/formatUtil'
import Personal from './personal'
import { Dialog } from 'vant';
export default {
    name: 'Anchor',
    components: {
        Personal,
        [Dialog.Component.name]: Dialog.Component
    },
    props: {
        anchorInfo: {
            type: Object,
            default() {
                return {}
            }
        },
        storeInfo: {
            type: Object,
            default() {
                return {}
            }
        },
        storeName: {
            type: String,
            default: ''
        }
    },
    mixins: [],
    computed: {
        hostBg () {
            if (
                this.anchorInfo.id === '617c3ed1d951a15e675f67b4' && 
                this.storeInfo.recommendImage
            ) {
                return this.storeInfo.recommendImage.url
            }
            if (this.anchorInfo.background) {
                return `https://media.shopshops.top/${this.anchorInfo.background}`
            }
            return 'https://fr-static.shopshops.top/20210420/anchor_bg.63e5c108b3a20cc6.png'
        }
    },
    data() {
        return {
            defaultHead:
                'https://fr-static.shopshops.top/20200328/default_header@2x.24f6dd3183b47f92.png',
            transPeople,
            certification: 0
        }
    },
    mounted() {
        this.getHostBrief()
    },
    methods: {
        async getHostBrief() {
             const params = {
                hostId: this.$route.query.hostId
            }
            const { code, result } = await api.get_host_brief(params)
            if (code) return
            this.certification = Number(result.role)
        },
        // 关注
        async concernHost() {
            const params = {
                hostId: this.anchorInfo.id,
                source: '主播资料页'
            }
            this.$loading()
            await api.like_host(params)
            await this.$parent.getAnchorInfos()
            this.$loading.close()
        },
        unconcernHostConfim() {
            Dialog.confirm({
                message: this.$t('message.anchor.confirmTxt'),
                confirmButtonText: this.$t('message.anchor.confirm'),
                cancelButtonText: this.$t('message.anchor.cancel')
            }).then(() => {
                this.unconcernHost()
            }).catch(() => {
                // on cancel
            });
        },
        // 取消关注
        async unconcernHost() {
             this.$loading()
            const params = {
                id: this.anchorInfo.userlikeHostId
            }
            await api.cancle_like_host(params)
            this.$parent.getAnchorInfos()
            this.$loading.close()
        },
        // 人数为1 follow 大于1 follows
        changeNum() {
            if (Number(this.anchorInfo.likeCount) > 1) {
                return this.$t('message.anchor.followers')
            }
            return this.$t('message.anchor.follower')
        }
    }
}
</script>
<style scoped lang="less">
.anchor-brief {
    position: relative;
    max-height: 250px;
    overflow: hidden;
    &-mask{
        position: absolute;
        background-image: linear-gradient(transparent, rgba(0,0,0,.6));
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    &-bg{
        img{
            visibility: hidden;
            width: 100%;
            vertical-align: top;
        }
    }
    .personal{
        justify-content: center;
        margin-top: 10px;
    }
    &-header {
        position: absolute;
        z-index: 1;
        text-align: center;
        padding-top: 8px;
        left: 0;
        right: 0;
        bottom: 0;
        padding-bottom: 16px;
        .header-img {
            width: 60px;
            height: 60px;
            border-radius: 30px;
        }
        .header-name {
            margin-top: 6px;
            color: #f2f2f2;
            font-size: 16px;
            font-family: "TradeGothicLT";
        }
        .header-body{
            color: #f2f2f2;
            font-size: 13px;
            line-height: 18px;
            margin-top: 8px;
            span{
              margin: 0 2.5px;
            }
        }
        .header-focus {
            margin-top: 12px;
            display: flex;
            justify-content: center;
            height: 25px;
            &-text {
                color: #f2f2f2;
                font-size: 13px;
                line-height: 25px;
                font-family: "TradeGothicLT";
            }
            &-btn {
                font-family: "TradeGothicLT";
                width: 77px;
                line-height: 25px;
                margin-left: 18px;
                color: #f2f2f2;
                font-size: 12px;
                border: 0.5px solid #f2f2f2;
                border-radius: 13px;
            }
        }
    }
    &-brief {
        padding: 16px 26px;
        width: 350px;
        // height: 14700px;
        background: #fff;
        border-radius: 10px;
        margin: 0 auto;
        margin-top: 20px;
        .brief-title {
            color: #ffffff;
            font-size: 15px;
            font-weight: 600;
            margin-bottom: 6px;
        }
        .brief-item {
            display: block;
            color: #666666;
            font-size: 12px;
            line-height: 20px;
        }
    }
}
</style>
